//
// Delgation for zones.
// Provides helper methods for working with zones.
function ANZoneDelegate(logger){

    var self                    = this;
    this.logger                 = logger || new AdsNinjaLogger();
    this.totalMapped            = 0;
    this.__mapping              = {};
    this.__mappingByElementId   = {};
    this.__refreshData          = null;
    this.__zoneUses             = {};
    this.__intersectionObserver = new IntersectionObserver(this.__intersectionObserverCallback.bind(this), {
        threshold: 0.5,
        // threshold: [0.3, 0.5],
    });

    var callback = this.refreshInViewZones();

    // TODO: Move to refresh manager?
    window.addEventListener('pageshow', callback);
    window.addEventListener('focus', callback);
    window.addEventListener('visibilitychange', callback);
}

//
// Initialize.
ANZoneDelegate.prototype.init = function(data, refreshData){
    
    if(!window.adsNinjaHeaderBiddingManager){

        this.logger.error('Unable to initialize ANZoneDelegate.');
        
        return;
    }

    this.__refreshData = refreshData;

    for(const x in data){
        
        window.adsNinjaHeaderBiddingManager.__createAndAddNewAdData(data[x]);
    }
};

//
// Add zone to be mapped.
ANZoneDelegate.prototype.map = function(item, isCopy = false){
    
    if(!item || !item.hasOwnProperty('adElementId') || !item.hasOwnProperty('zoneName') || !item.hasOwnProperty('zoneGroupName')){

        return;
    }

    // Try to find a base zone, unless the current zone is a base zone.
    var baseZoneInfo    = null;
    var adElementId     = item.adElementId; 
    var baseAdElementId = item.getOriginalAdElementId();
    var zoneInfo        = null;
        
    // if(baseAdElementId !== adElementId){
    if(baseAdElementId !== adElementId && !isCopy){

        baseZoneInfo = new ANZoneInfo(item.__originalAdData.zone.name, item.__originalAdData.zone.groupName, baseAdElementId);
        zoneInfo     = new ANZoneInfo(item.zoneName, item.zoneGroupName, adElementId, baseZoneInfo);
    }
    else if(baseAdElementId !== adElementId && isCopy){

        var nonCountAdElementIdParts = adElementId.split('-count-');
        var nonCountAdElementId      = (nonCountAdElementIdParts.length > 0) ? nonCountAdElementIdParts[0] : null;

        if(baseAdElementId !== nonCountAdElementId){

            baseZoneInfo = new ANZoneInfo(item.__originalAdData.zone.name, item.__originalAdData.zone.groupName, baseAdElementId);
        }

        zoneInfo = new ANZoneInfo(item.zoneName, item.zoneGroupName, nonCountAdElementId, baseZoneInfo);
    }
    else{

        zoneInfo = new ANZoneInfo(item.zoneName, item.zoneGroupName, baseAdElementId, baseZoneInfo);
    }
        
    var key = zoneInfo.getKey();

    if(key.includes('-count-')){

        throw new Error(`Invalid zone key.`, {
            item : item,
            base : baseZoneInfo,
            zone : zoneInfo,
            key  : key,
        });
    }

    if(!this.__mapping.hasOwnProperty(key)){

        this.__mapping[key] = new ANZoneDictionaryItem(zoneInfo, this.__intersectionObserver);
    }

    this.__mapping[key].addUnit(item);

    this.__mappingByElementId[adElementId] = zoneInfo;

    this.totalMapped++;

    // HACK: While we wait for full zone manager support we have to do this.
    this.__mapping[key].getElement();
};

// //
// // Get current ad in zone.
// ANZoneDelegate.prototype.getCurrentUnitInZone = function(zoneInfo){

//     var key = zoneInfo.getKey();

//     return this.__mapping[key].current || null;
// };

// //
// // Rotate items in zone.
// ANZoneDelegate.prototype.rotateItemsInZone = function(zoneInfo){
    
//     var key = zoneInfo.getKey();

//     if(!this.__mapping.hasOwnProperty(key)){

//         return;
//     }

//     this.__mapping[key].previous = this.__mapping[key].current || null;
//     this.__mapping[key].current  = this.__mapping[key].next || null;
//     this.__mapping[key].next     = null;
// };

/**
 * Creates a new zone.
 * 
 * @param {Object} baseZoneInfo
 * @param {number} zoneIndex
 * @param {string} decoration
 * @returns {Object}
 */
ANZoneDelegate.prototype.__createZone = function(baseZoneInfo, zoneIndex, decoration = 'infinite'){

    var newZoneInfo                   = JSON.parse(JSON.stringify(baseZoneInfo));
    newZoneInfo.base                  = baseZoneInfo;
    newZoneInfo.name                  = `${newZoneInfo.name}_${decoration.toUpperCase()}_${zoneIndex}`;
    newZoneInfo.originalItemElementId = `${newZoneInfo.originalItemElementId}_${decoration.toUpperCase()}_${zoneIndex}`;
    newZoneInfo                       = new ANZoneInfo(newZoneInfo.name, newZoneInfo.groupName, newZoneInfo.originalItemElementId, newZoneInfo.base);

    // Validate that zone doesn't already exist.
    if(this.__mapping.hasOwnProperty(newZoneInfo.getKey())){

        throw new Error(`Unable to create new zone one already exists: ${newZoneInfo.getKey()}`);
    }

    // Create new zone.
    return this.__createZoneFromTemplate(baseZoneInfo, newZoneInfo);
};

//
// Create new zone from template.
ANZoneDelegate.prototype.__createZoneFromTemplate = function(originalZoneInfo, newZoneInfo){

    var originalKey = originalZoneInfo.getKey();

    if(!this.__mapping.hasOwnProperty(originalKey)){

        throw new Error(`Unable to find original zone: ${originalKey}`);
    }

    var newKey = newZoneInfo.getKey();

    if(this.__mapping.hasOwnProperty(newKey)){

        throw new Error(`Unable to create new zone: ${newKey}`);
    }

    newZone = new ANZoneDictionaryItem(newZoneInfo, this.__intersectionObserver);

    // Copy ad data.
    var originalItem = this.__mapping[originalKey].getOriginalUnit();

    if(!originalItem){

        throw new Error('Cannot create a new zone.');
    }

    // Setup item for new zone.
    var newItem = JSON.parse(JSON.stringify(originalItem));
    newItem     = this.__cleanItemForNewZone(newZoneInfo, newItem);

    // Add new original item to new zone.
    newZone.addUnit(newItem);

    // Create bid pool.
    window.adsNinjaHeaderBiddingManager.__createBidPool(newItem.getBidPoolName());

    // Add to ad list.
    window.adsNinjaHeaderBiddingManager.__addNewAdData(newItem);

    this.__mapping[newKey]                                       = newZone;
    this.__mappingByElementId[newZoneInfo.originalItemElementId] = newZoneInfo;

    return this.__mapping[newKey];
};

//
// Get refresh delegate.
ANZoneDelegate.prototype.__getRefreshDelegate = function(itemId){
    
    return window.adsNinjaHeaderBiddingManager.getRefreshingAdZone(itemId);
};

//
// Clean unit data.
ANZoneDelegate.prototype.__cleanItemForNewZone = function(newZoneInfo, item){

    // This is important to do so that we don't end up with duplicate ad elements.
    item.zoneName               = newZoneInfo.name;
    item.zoneGroupName          = newZoneInfo.groupName;
    item.adElementId            = newZoneInfo.originalItemElementId;
    item.onPageLoad             = false;
    item.bidPoolName            = `${newZoneInfo.groupName}_${newZoneInfo.name}`;
    item.pageNumber             = 1;
    // item.__originalAdData.divId = newZoneInfo.originalItemElementId;
    item                        = new AdsNinjaAdUnit(item); 

    return item;
};

//
// Find base zone.
ANZoneDelegate.prototype.findBaseZone = function(zoneName, zoneGroupName){

    if(!zoneName || !zoneGroupName){

        return null;
    }

    zoneName         = zoneName.toLowerCase();
    zoneGroupName    = zoneGroupName.toLowerCase();
    var mappingArray = Object.values(this.__mapping);

    for(var i = 0; i < mappingArray.length; i++){

        var entry              = mappingArray[i];
        var entryZoneInfo      = entry.zoneInfo;
        var entryZoneName      = (entryZoneInfo) ? entryZoneInfo.name : '';
        entryZoneName          = entryZoneName.toLowerCase();
        var entryZoneGroupName = (entryZoneInfo) ? entryZoneInfo.groupName : '';
        entryZoneGroupName     = entryZoneGroupName.toLowerCase();

        if(!entry.base && entryZoneName === zoneName && entryZoneGroupName === zoneGroupName){

            return entry;
        }
    }

    return null;
};

//
// Create refresh delegate.
ANZoneDelegate.prototype.createRefreshDelegate = function(baseZone, adElementId){

    // Make new refreshingAdZones entry.
    var ad = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);

    if(!ad){

        throw new Error('Unable to setup dynamic injection refresh ad zone: ad cannot be found.');
    }

    // TODO: Revisit this.
    var refreshData          = {};
    refreshData[adElementId] = this.__refreshData[baseZone.getOriginalUnitElementId()] || {};

    window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones([ad], refreshData);
};

/**
 * Add zone to page.
 * 
 * @param {HTMLElement} elementOfIntrest 
 * @param {string} injectionPlacement 
 * @param {Object} baseZone 
 * @param {Object} zoneIndex 
 * @param {Function} contentFormatter 
 * @returns {Object}
 */
ANZoneDelegate.prototype.addNewZoneToPageFromTemplate = function(elementOfIntrest, injectionPlacement, baseZone, zoneIndex, contentFormatter = null){

    if(!baseZone){

        throw new Error('Unable to add new zone to page: Base zone not provided.');
    }

    var newZone = null;

    if(!baseZone.hasBeenAddedToPage() && window.adsNinja.isInjectorInjected){
        
        // Use base zone, it hasn't been added to the page yet.
        newZone = baseZone;
    }
    else if(baseZone.isRepeatable()){

        // Get repeatable zone instance.
        newZone = this.getRepeatableZoneInstance(baseZone, zoneIndex);
    }
    else{

        // Create new zone.
        var baseZoneInfo = baseZone.getZoneInfo();    
        newZone          = this.__createZone(baseZoneInfo, zoneIndex);
    }

    if(!newZone || newZone.hasBeenAddedToPage()){
        
        throw new Error('Unable to add new zone to page: New zone not created.');
    }

    var newZoneInfo = newZone.getZoneInfo();

    // Get ad.
    var newItem = newZone.getOriginalUnit();

    // TODO: Consider re-using existing ads.

    if(!newItem){

        throw new Error('Unable to add new zone to page: Unable to find original unit.');
    }

    // Get contents of ad.
    var newItemParts = newItem.createContentAndHeader(); 
    var content      = newItemParts.content;

    // Format content.
    if(typeof contentFormatter === 'function'){

        content = contentFormatter(content);
    }

    // Inject ad.
    elementOfIntrest.insertAdjacentHTML(injectionPlacement, content);
    
    var newZoneElement         = newZone.getElement(); 
    newZoneElement.dataset.key = newZoneInfo.getKey();

    try{

        window.Function(window.adsNinjaHeaderBiddingManager.__stripScriptTags(newItemParts.header))();
    }
    catch(error){

        // Ignore, case where header is already on the page.
        this.logger.error('Unable to add new zone to page: Unable to inject unit header.', {
            error: error,
        });
    }

    newZone.setHasBeenAddedToPage();

    // Setup refresh.
    this.createRefreshDelegate(baseZone, newItem.adElementId);

    return newZone;
};

//
// Setup floating.
ANZoneDelegate.prototype.setupFloating = function(ad){

    window.adsNinjaHeaderBiddingManager.setupFloatingAdZones([ad]);
};

/**
 * Copy ad capabilities.
 * 
 * @param {Object} originalItem 
 * @param {Object} newItem 
 */
ANZoneDelegate.prototype.copyAdCapabilities = function(originalItem, newItem){

    // TODO: Look to remove the need for capabilities.
    window.adsNinjaHeaderBiddingManager.copyAdCapabilities(originalItem, newItem);
};

//
// Returns a zone by key.
ANZoneDelegate.prototype.get = function(key){

    return this.__mapping[key] || null;
};

//
// Returns a zone by element id.
ANZoneDelegate.prototype.getByElementId = function(elementId){

    var zoneInfo = this.__mappingByElementId[elementId] || null;

    if(!zoneInfo){

        return null;
    }

    return this.__mapping[zoneInfo.getKey()] || null; 
};

//
// Returns zones with repeatable settings.
ANZoneDelegate.prototype.getRepeatableZones = function(){
  
    return Object.values(this.__mapping).filter(function(zone){ return zone.isRepeatable(); });
};

/**
 * Returns all zones with ads that can float.
 * 
 * @returns {Array}
 */
ANZoneDelegate.prototype.getFloatingZones = function(){
  
    var zones = [];

    for(var key in this.__mapping){

        var zone = this.__mapping[key];

        if(zone.canFloat()){

            zones.push(zone);
        }
    }

    return zones;
};

/**
 * Returns all zones with ads that are always floating in them.
 * 
 * @returns {Array}
 */
ANZoneDelegate.prototype.getAlwaysFloatingZones = function(){
  
    var zones = [];

    for(var key in this.__mapping){

        var zone = this.__mapping[key];

        if(zone.isAlwaysFloating()){

            zones.push(zone);
        }
    }

    return zones;
};

/**
 * Returns a preview of the next repeatable zone.
 * 
 * @param {Object} baseZone
 * @param {number} zoneIndex
 * @returns {Object}
 */
ANZoneDelegate.prototype.getRepeatableZoneInstance = function(baseZone, zoneIndex = 0){
  
    var repeatableSettings = baseZone.getRepeatableSettings();

    // Check if zone is repeatable.
    if(!baseZone || !baseZone.isRepeatable() || !repeatableSettings){

        return null;
    }

    var zoneUses = this.__zoneUses[baseZone.getKey()] || {};

    if(zoneUses && zoneUses[zoneIndex]){

        return zoneUses[zoneIndex];
    }

    var baseChildZone = null;

    for(var x in baseZone.children){

        var childZoneDetails = baseZone.children[x];
        var baseChildZone    = null;

        if((ANZoneDictionaryItem.ID_POSITION_TYPE_AT === childZoneDetails.positionType && childZoneDetails.position === zoneIndex)
            || (ANZoneDictionaryItem.ID_POSITION_TYPE_EVERY === childZoneDetails.positionType && 0 === childZoneDetails.position % zoneIndex)
        ){

            baseChildZone = this.findBaseZone(childZoneDetails.name, childZoneDetails.groupName);
        }

        if(!baseChildZone){

            break;
        }
    }

    if(!baseChildZone){

        baseChildZone = baseZone;
    }

    // Create new zone.
    var baseZoneInfo = (baseChildZone.base) ? baseChildZone.base.zoneInfo : baseChildZone.zoneInfo;
    var newZone      = this.__createZone(baseZoneInfo, zoneIndex, 'repeat');

    if(!this.__zoneUses[baseZone.getKey()]){

        this.__zoneUses[baseZone.getKey()] = {};
    }
    
    if(!this.__zoneUses[baseZone.getKey()][zoneIndex]){

        this.__zoneUses[baseZone.getKey()][zoneIndex] = newZone;
    }    

    // Copy ad capabilities.
    var newItem = newZone.getOriginalUnit();

    if(!newItem){

        throw new Error('Unable to find original unit.');
    }

    this.copyAdCapabilities(baseZone.getOriginalUnit(), newItem);

    return newZone;
};

/**
 * Returns number of zones.
 * 
 * @param {boolean} isPrinted
 * @returns {number}
 */
ANZoneDelegate.prototype.getNumberOfZones = function(onPageOnly = true){
  
    if(onPageOnly){

        var hasBeenAddedToPageCount = 0;

        for(var key in this.__mapping){

            var zone = this.__mapping[key];

            hasBeenAddedToPageCount += (zone.hasBeenAddedToPage()) ? 1 : 0;
        }

        return hasBeenAddedToPageCount;
    }

    return Object.keys(this.__mapping).length;
};

/**
 * Refresh zones.
 * 
 * @param {Array} zones
 */
ANZoneDelegate.prototype.refreshZones = function(zones = []){
  
    if(!zones.length){

        return;
    }

    // TODO: Change ownership.
    for(var i = 0; i < zones.length; i++){
        
        var zone = zones[i];

        if(!zone.hasBeenAddedToPage()){

            continue;
        }

        // TODO: Add back in in later version.
        // if(!zone.hasCurrentCreativeBeenLoaded() || !zone.hasCurrentCreativeBeenViewed() || !zone.hasCreativeMinimumTimerCompleted()){

        //     continue;
        // }

        var currentUnitElementId = zone.getCurrentUnitElementId();

        if(!currentUnitElementId){
            
            continue;
        }

        window.adsNinjaHeaderBiddingManager.refreshAdElement(currentUnitElementId, 'inView');
    }

    // TODO: Maybe we can group zones for auctions.
};

/**
 * Setup next ad for zones.
 * 
 * @param {Array} zones
 */
ANZoneDelegate.prototype.setupNextAdForZones = function(zones = []){
  
    if(!zones.length){

        return;
    }

    // TODO: Change ownership.
    for(var i = 0; i < zones.length; i++){
        
        var zone = zones[i];

        if(!zone.hasBeenAddedToPage()){

            continue;
        }

        // TODO: Add back in in later version.
        // if(!zone.hasCurrentCreativeBeenLoaded() || !zone.hasCurrentCreativeBeenViewed() || !zone.hasCreativeMinimumTimerCompleted()){

        //     continue;
        // }

        var currentUnitElementId = zone.getCurrentUnitElementId();

        if(!currentUnitElementId){
            
            continue;
        }

        var refreshingAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[currentUnitElementId];

        if(!refreshingAdZone){
            
            continue;
        }

        window.adsNinjaHeaderBiddingManager.setupNextAd(currentUnitElementId, refreshingAdZone, true, 'inView');
    }

    // TODO: Maybe we can group zones for auctions.
};

/**
 * Refresh zones.
 */
ANZoneDelegate.prototype.refreshInViewZones = function(){
  
    var self = this;

    return window.adsNinja.eventHelper.throttle(function(){
        
        if(document.visibilityState !== 'visible'){

            return;
        }

        self.refreshZones(self.getZonesInView());
    }, 1000);
};

/**
 * Returns zones in view.
 * 
 * @returns {Array}
 */
ANZoneDelegate.prototype.getZonesInView = function(){
  
    return Object.values(this.__mapping).filter(function(zone){ return zone.isInView(); }) || [];
};

/**
 * Intersection observer callback.
 * 
 * @param {Array} entries
 */
ANZoneDelegate.prototype.__intersectionObserverCallback = function(entries){
  
    var zonesToRefresh = [];

    for(var i = 0; i < entries.length; i++){
        
        var entry   = entries[i];
        var zoneKey = entry.target.dataset.key;

        if(!zoneKey){

            this.__logger.error('Zone key not found in data set!');
            continue;
        }

        var zone = window.adsNinja.zoneDelegate.get(zoneKey);

        if(!zone){

            this.__logger.error('Zone not found!');
            continue;
        }

        var inViewRatio = 0.5;

        // TODO: Use the 30% ratio for big ads?
        if(false && entry.target.clientHeight * entry.target.clientWidth >= 242500 && !zone.isVideo()){

            // Using the viewability metric, if this is a big ad, use a smaller intersection ratio.
            inViewRatio = 0.3;
        }

        var currentUnitElementId = zone.getCurrentUnitElementId();

        // TODO: Support multiple containers.
        // Also supports floating and do not use space.
        var isInView = (entry.intersectionRatio >= inViewRatio || (currentUnitElementId && window.adsNinjaHeaderBiddingManager.isAdFloating(currentUnitElementId)));

        // TODO: Try to base off creative instead of zone.
        zone.setIsInView(isInView);

        if(isInView){

            zonesToRefresh.push(zone);
        }
    }

    // TODO: Try to refresh ad.
    if(false){
        
        this.setupNextAdForZones(zonesToRefresh);
    }
    this.refreshZones(zonesToRefresh);
};

window.ANZoneDelegate = ANZoneDelegate;